import { Alert, Button } from "antd";
import React from "react";

export default function StartupState({ error, onRetry }) {
  return (
    <div className="startup-loading">
      <div>
        {error
          ? (
            <>
              <Alert message={error} type="error" showIcon />
              <Button style={{ marginTop: 16 }} onClick={onRetry}>
                Réessayer
              </Button>
            </>
          )
          : (
            <>
              <div className="startup-loader" />
              <p>Le chargement peut prendre quelques secondes...</p>
            </>
          )}
      </div>
    </div>
  );
}
